import { applyFilters, doRequest } from "./helpers";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";

export default class NoteTemplateService {
  static async getTable(filters = null) {
    let path = "/note_template/";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getForFilters(filters = null) {
    let path = "/note_template/for_filters";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async get(id) {
    return doRequest("GET", `/note_template/${id}`);
  }

  static async create(data) {
    return doRequest("POST", "/note_template/", { data: omitBy(data, isNil) });
  }

  static async update(id, data) {
    return doRequest("PUT", `/note_template/${id}`, {
      data: omitBy(data, isNil),
    });
  }

  static async delete(id) {
    return doRequest("DELETE", `/note_template/${id}`);
  }
}
